import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

//Nav
import OpsStrucureNav from "./OpsStrucureNav";
import OpsStrucureContent from "./OpsStrucureContent";

//DataTable
import { ViewCompanyProfile } from "../../../../Types/CompanyProfile/CompanyProfile";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const OpsStrucureCard = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const [basicTab, setBasicTab] = useState("1");

  return (
    <Card className="card-absolute">
      <CommonCardHeader
        headClass="bg-primary"
        tagClass="txt-light"
        title={"Operational Structure"}
      />

      <CardBody>
        <OpsStrucureNav basicTab={basicTab} setBasicTab={setBasicTab} />
        <OpsStrucureContent tabId={basicTab} companyInfo={companyInfo} />
      </CardBody>
    </Card>
  );
};

export default OpsStrucureCard;
